import { Suspense } from "react";
import LoadingPageComponent from "../components/GeneralComponents/LoadingPageComponent";
import { Route } from "react-router";
import { lazy } from "react";
const HomePage = lazy(() => import('../pages/HomePage'))
const AboutMePage = lazy(()=> import('../pages/AboutMePage'))
const ProjectsPage = lazy(() => import('../pages/ProjectsPage'))
const MediaPage = lazy(()=> import ('../pages/MediaPage'))

export const innovativeURL = "https://rchrdlss3.github.io/InnovativeRich";
export const githubURL = 'https://api.github.com/users/Rchrdlss3/';

export const navigationLinks = [
    {
        name: "Home",
        path: "/",
        element: <HomePage />
    },
    {
        name: "About Me",
        path: "/about-me",
        element: <AboutMePage />
    },
    {
        name: "Projects",
        path: "/projects",
        element: <ProjectsPage />
    },
    {
        name: "Media",
        path: "/media",
        element: <MediaPage />
    }
];

export const cardImageWidth = 50;

export const pageSuspense = (component) => {
    return <Suspense fallback = {<LoadingPageComponent />}>{component}</Suspense>
};

export const AppRoutes = () => {
    return navigationLinks.map((navigation) => 
        <Route key = {navigation.name} path = {navigation.path} element={pageSuspense(navigation.element)}/>
    )
};

export const GLOBE_EARTH_BLUE_URL = "https://unpkg.com/three-globe@2.31.1/example/img/earth-blue-marble.jpg";
export const GLOBE_EARTH_NIGHT_URL = "https://unpkg.com/three-globe/example/img/earth-night.jpg";